import { get } from 'lodash';
import { RootScopeEvents } from '../../root-scope-types';
import { ErrorTrack } from '../error.track';
export default class RealtimeError extends ErrorTrack {
    start() {
        this.$rootScope.$on(RootScopeEvents.REALTIME.ERROR, (e, { error, action }) => {
            this.trackSegment({
                errorType: 'RealtimeError',
                errorCode: get(error, 'status.operation') || action,
                errorMessage: get(error, 'status.errorData.message') || get(error, 'message'), // try to get origin first
            });
        });
    }
}
